import { Box, Container, Grid } from "@mui/material";

import Loading from "../../../components/Loading";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { useUserContext } from "../context";
import { UserProfileUpdate } from "../components/UserProfileUpdate";
import { UserTitle } from "../components/UserTitle";
import Intercom from "@intercom/messenger-js-sdk/dist";
import { useEffect } from "react";
import { TransitionOverlay } from "../../../components/TransitionOverlay";

export const SettingsProfile = () => {
  const { user } = useAuth0();
  const { userContext, loadUserContext } = useUserContext();

  useEffect(() => {
    if (process.env.REACT_APP_INTERCOM_APP_ID) {
      Intercom({
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
        user_id: userContext.dbUser?.uuid,
        name: userContext.dbUser?.profile?.name,
        email: userContext.dbUser?.email_address,
        created_at: (new Date(userContext.dbUser?.created_at)).valueOf(), // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
      });
    }
  }, [userContext.dbUser]);


  if (!userContext.fetched || !userContext.dbUser) {
    return <TransitionOverlay open={true} message="Loading..." />;
  }

  return (
    <Box>
      <UserTitle section="Your Profile" subheading="Manage how you appear to others." />
      <UserProfileUpdate user={userContext.dbUser} onUpdate={loadUserContext} />
    </Box>
  );
};
